<template>
  <div>
    <Head title="Create Purchase Order" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/purchaseorders">Purchase Orders</Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.purchase_request_id" :error="form.errors.purchase_request_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Purchase Request">
            <option v-for="purchasereq in purchaserequests" :key="purchasereq.id" :value="purchasereq.id">{{ purchasereq.code }}</option>
          </select-input>
          <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Supplier">
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <text-input v-model="pr.project" class="pb-8 pr-6 w-full lg:w-1/2" label="Project" readonly />
          <text-input v-model="pr.pr_activity" class="pb-8 pr-6 w-full lg:w-1/2" label="PR Activity" readonly />
          <text-input :model-value="formatDate(form.po_date)" :error="form.errors.po_date" class="pb-8 pr-6 w-full lg:w-1/2" label="PO Date" disabled />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Description" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Purchase Order</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import { format, parse } from 'date-fns'

//TODO: benahi standar penamaan props dan data
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextareaInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Object,
    purchaserequests: Object,
    date: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        organization_id: null,
        purchase_request_id: null,
        po_date: this.date,
        description: null,
      }),
      pr: {
        pr_activity: null,
        project: null,
      },
    }
  },
  watch: {
    'form.purchase_request_id': function (newVal) {
      this.projectActivityByPR(newVal)
    },
  },
  methods: {
    store() {
      this.form.post('/purchaseorders')
    },
    projectActivityByPR(prId){
      fetch(`/projectactivity?pr=${prId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.pr.pr_activity = data.data.pr_activity
          this.pr.project = data.data.project
        })
    },
    formatDate(ymd) {
      return format(parse(ymd, 'yyyy-MM-dd', new Date()), 'dd-MMM-yyyy')
    },
  },
}
</script>
